<ng-container *ngIf="allowChangeStore()">
    <button
        type="button"
        [disabled]="!allowChangeStore()"
        (click)="changeStore.emit()"
        class="kk-btn change-store-button"
        [ngClass]="{
            'is-invalid': !canReserve(),
            'remove-cursor': !allowChangeStore()
        }"
    >
        <app-svg-icon iconName="location"></app-svg-icon>
        {{ storeName() }}
        <app-svg-icon *ngIf="allowChangeStore()" class="arrow-icon" iconName="chevron_right"></app-svg-icon>
    </button>
</ng-container>

<ng-container *ngIf="!allowChangeStore()">
    <div class="kk-btn change-store-button">
        <app-svg-icon iconName="location"></app-svg-icon>
        {{ storeName() }}
        <app-tooltip
            class="arrow-icon"
            *ngIf="(storeId() | canChangeStoreInReservation | async) === false"
            [title]="'reservation.tooltip.title' | translateSafe"
        >
            <span [innerHTML]="'reservation.tooltip.text' | translateSafe"></span>
        </app-tooltip>
    </div>
</ng-container>

@if (!canReserve() && showTooltip()) {
    <app-tooltip type="warning">
        {{ 'reservation.tooltip.storeReservationNotAllowed' | translateSafe }}
    </app-tooltip>
}
